import { useEffect, useRef } from "react";
import type { LoadPhase } from "src-next/modules/clinical-insights/loadPhase";

/** Sincroniza fase `records` → `done` para bundles FHIR (sem fase `patients`). */
export function useFhirInsightLoadPhase(
  enabled: boolean,
  loading: boolean,
  onLoadPhaseChange?: (phase: LoadPhase) => void
) {
  const hasDataRef = useRef(false);
  const onLoadPhaseChangeRef = useRef(onLoadPhaseChange);
  onLoadPhaseChangeRef.current = onLoadPhaseChange;

  useEffect(() => {
    if (!enabled) return;
    if (loading) {
      onLoadPhaseChangeRef.current?.("records");
    } else {
      hasDataRef.current = true;
      onLoadPhaseChangeRef.current?.("done");
    }
  }, [enabled, loading]);

  return { hasData: hasDataRef.current };
}
